'use client';

import {
  normalizeProjectDirections,
  projectDirectionOptions,
  toggleProjectDirection,
  type ProjectDirection,
} from '@/lib/projectDirections';

type ProjectDirectionPickerProps = {
  value: readonly ProjectDirection[];
  onChange: (directions: ProjectDirection[]) => void;
  disabled?: boolean;
};

export default function ProjectDirectionPicker({ value, onChange, disabled = false }: ProjectDirectionPickerProps) {
  return (
    <fieldset disabled={disabled} className="min-w-0 space-y-2">
      <legend className="text-sm font-medium text-site-secondary">Направления проекта</legend>
      <div className="flex flex-wrap gap-2">
        {projectDirectionOptions.map(({ id, label }) => (
          <label
            key={id}
            className={`inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm transition-colors ${
              value.includes(id)
                ? 'border-site-accent/50 bg-site-accent/10 text-site-text'
                : 'border-site-border-control/50 bg-site-surface/50 text-site-secondary'
            } ${disabled ? 'opacity-60' : 'cursor-pointer hover:border-site-accent/50'}`}
          >
            <input
              type="checkbox"
              name="project-directions"
              value={id}
              checked={value.includes(id)}
              disabled={disabled}
              onChange={() => onChange(toggleProjectDirection(value, id))}
              className="accent-site-accent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-site-accent"
            />
            {label}
          </label>
        ))}
      </div>
      <p className="text-xs text-site-muted">Можно выбрать несколько. Категории определяют разделы витрины; публикация и модерация проекта остаются обязательными.</p>
    </fieldset>
  );
}

export function ProjectDirectionLabels({ value }: { value: unknown }) {
  const selected = normalizeProjectDirections(value);
  if (!selected.length) return null;
  return (
    <ul aria-label="Направления проекта" className="my-3 flex flex-wrap gap-2">
      {projectDirectionOptions.filter(({ id }) => selected.includes(id)).map(({ id, label }) => (
        <li key={id} className="rounded-full border border-site-border-control/50 bg-site-raised/50 px-2 py-1 text-xs text-site-secondary">
          {label}
        </li>
      ))}
    </ul>
  );
}
